// components/canvas-toolbar/useCanvasEvents.ts
import { useEffect } from 'react'

export function useCanvasEvents(canvas: any, handleObjectSelect: any, setSelectedObject: any) {
  useEffect(() => {
    if (!canvas) return

    const handleSelectionCreated = (event: any) => {
      if (event.selected && event.selected[0]) {
        handleObjectSelect(event.selected[0])
      }
    }

    const handleSelectionCleared = () => {
      setSelectedObject(null)
    }

    const handlePathCreated = (event: any) => {
      event.path.erasable = true
    }

    canvas.on('selection:created', handleSelectionCreated)
    canvas.on('selection:cleared', handleSelectionCleared)
    canvas.on('path:created', handlePathCreated)

    return () => {
      canvas.off('selection:created', handleSelectionCreated)
      canvas.off('selection:cleared', handleSelectionCleared)
      canvas.off('path:created', handlePathCreated)
    }
  }, [canvas, handleObjectSelect, setSelectedObject])
}
